module.exports = __webpack_public_path__ + "static/media/mercado-modelo-uniforme-polo-personalizado.79391552.jpg";